module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-small.RU.cb81706e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-small.RU.png
// module id = 3113
// module chunks = 11